// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TP69","label":"styles_label__2fK73"};